import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLoader } from "@react-three/fiber";
import { STLLoader } from "three/addons/loaders/STLLoader";
import { connect } from "react-redux";
import action from "../../../store/action";
import * as THREE from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";

/**
 * @description create gum function. In order to batch creation gum
 * @param props The parameter passed by the attribute within the tag
 * */
function Hooks(props) {
  const { model, visible, opacity = 1 } = props;

  return (
    <mesh geometry={model} renderOrder={1} visible={visible}>
      <meshStandardMaterial
        color={"cyan"}
        transparent={true}
        opacity={opacity}
        depthWrite={opacity > 0.5 ? true : false}
        depthTest={true}
        roughness={0.4}
        metalness={0}
        reflectivity={0.3}
        flatShading={true}
      />
    </mesh>
  );
}

export default Hooks;
